'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('SignalsListCtrl', [
	'$scope',
	'$http',
	'$filter',
	'$uibModal',
	'$log',
	'$timeout',
	function ($scope, $http, $filter, $uibModal, $log, $timeout) {

		$scope.items = [];
		$scope.sortField = 'id';
		$scope.sortReverse = false;
		$scope.currentPage = 1;
		$scope.itemsPerPage = 20;
		$scope.totalItems = 0;
		$scope.numPages = undefined;
		$scope.filter = {};
		$scope.isFilters = false;
		$scope.canEdit = false;

		$scope.loadItems = function () {
			if ($scope.dataUrl !== '') {
				$http.get($scope.dataUrl)
						.then(function (response) {
							var data = response.data;
							if (data.success) {
								if (angular.isDefined(data.items)) {
									$scope.items = data.items;
									$scope.totalItems = $scope.items.length;
								}
							} else if (angular.isDefined(data.message)) {
								$log.info(data.message);
							}
							if (angular.isDefined(data.debug)) {
								$log.debug(data.debug);
							}
						})
						.catch(function (err) {
							$log.error('Failed to load items:', err);
						});
			} else {
				$log.warn('No URL! url_template: ' + $scope.dataUrl);
			}
		};

		$scope.sortState = function (col) {
			if ($scope.sortField == col) {
				return $scope.sortReverse ? -1 : 1;
			}
			return 0;
		};

		$scope.setSort = function (col) {
			if ($scope.sortField == col) {
				$scope.sortReverse = !$scope.sortReverse;
			} else {
				$scope.sortField = col;
				$scope.sortReverse = false;
			}
		};

		$scope.getPageList = function () {
			var ordered = $filter('filter')($scope.items, $scope.filter);
			$scope.totalItems = ordered.length;
			ordered = $filter('orderBy')(ordered, $scope.sortField, $scope.sortReverse);
			var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
			var end = start + $scope.itemsPerPage;
			return ordered.slice(start, end);
		};

		$scope.cleanFilters = function () {
			$scope.filter = {};
			$scope.setFilters();
		};

		$scope.setFilters = function () {
			$scope.isFilters = false;
			for (var i in $scope.filter) {
				if ($scope.filter[i] != '') {
					$scope.isFilters = true;
				}
			}
		};

		$scope.sortingClass = function (fld) {
			var st = $scope.sortState(fld);
			if (st === 0)
				return 'sorting';
			if (st === 1)
				return 'sorting_asc';
			if (st === -1)
				return 'sorting_desc';
		};

		$scope.sortingArrow = function (fld) {
			var st = $scope.sortState(fld);
			if (st === 1)
				return 'fa-arrow-down';
			if (st === -1)
				return 'fa-arrow-up';
		};

		$scope.addItem = function () {
			var new_item = {
				id: '0',
				description: '',
				responsible: '',
				deadline: '',
				status: ''
			};
			$scope.editor(new_item);
		};

		$scope.editItem = function (item) {
			$scope.editor(item);
			$scope.initJqueryDatpicker();
		};

		$scope.initJqueryDatpicker = function () {
			$timeout(function () {
				if ($('#pikaday_input').length) {
					$('#pikaday_input').pikaday({
						firstDay: 1,
						format: 'YYYY-MM-DD',
						showDaysInNextAndPreviousMonths: true,
						i18n: {
							previousMonth: 'Praėjęs mėnesis',
							nextMonth: 'Sekantis mėnesis',
							months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
							weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
							weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
						}
					});
				}
			}, 400);
		};

		$scope.editor = function (item) {
			if (!$scope.canEdit) {
				return null;
			}
			var modalInstance = $uibModal.open({
				templateUrl: 'signals/item_edit.html',
				controller: 'SignalsItemEditCtrl',
				// size: 'sm',
				resolve: {
					item: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (result) {
				var url = $scope.saveUrl;
				if (url !== '') {
					$http({
						method: 'POST',
						url: url,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success) {
									if (angular.isUndefined(item.id) || item.id < 1) {
										$scope.items.push(data.item);
									} else {
										angular.extend(item, data.item);
									}
								} else if (angular.isDefined(data.message)) {
									$log.info(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('Failed to save item:', err);
							});
				} else {
					$log.warn('No URL! url_template: ' + $scope.saveUrl);
				}
			});
		};
	}
]).directive('signalsItemsList', [function () {
				return {
					restrict: 'A',
					link: function (scope, element, attr) {
						scope.dataUrl = '';
						scope.saveUrl = '';
						scope.itemsPerPage = 20;

						if (attr.dataUrl && attr.dataUrl !== '') {
							scope.dataUrl = attr.dataUrl;
						}
						if (attr.saveUrl && attr.saveUrl !== '') {
							scope.saveUrl = attr.saveUrl;
						}
						if (attr.itemsPerPage && attr.itemsPerPage !== '' && attr.itemsPerPage > 0) {
							scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
						}
						scope.loadItems();
					}
				};
			}]);

EwSiteApp.controller('SignalsItemEditCtrl', [
	'$scope',
	'$uibModalInstance',
	'item',
	function ($scope, $uibModalInstance, item) {
		$scope.require = {
			description: true
		};
		$scope.item = angular.copy(item);

		$scope.statuses = ['Planuojama', 'Vykdoma', 'Atlikta', 'Sustabdyta'];

		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			for (var i in $scope.require) {
				$scope.require[i] = false;
			}
			$uibModalInstance.dismiss();
		};
	}
]);
